import { Button } from 'components/form'
import Card from '../surfaces/Card'
import styles from './ScrollSpySection.module.scss'
import strings from 'l10n'
import { ActionButton } from 'types/common'
import Tooltip from './Tooltip'
import clsx from 'clsx'

type ScrollSpySectionProps = {
  children: React.ReactNode
  title: string
  onEdit?: () => void
  actionBtn?: ActionButton
  disabled?: boolean
  pr?: string
  pl?: string
  btnEditId?: string
  disabledTooltip?: string
  className?: string
  headerClassName?: string
  contentClassName?: string
  titleClassName?: string
}

const ScrollSpySection = (props: ScrollSpySectionProps) => {
  const {
    children,
    title,
    onEdit,
    actionBtn,
    disabled,
    pr,
    pl,
    btnEditId,
    disabledTooltip,
    className,
    headerClassName,
    contentClassName,
    titleClassName,
  } = props

  return (
    <Card
      classes={{
        root: clsx(styles.sectionLayoutContainer, className),
      }}
    >
      <div className={clsx(styles.sectionLayoutHeader, headerClassName)}>
        <div className={clsx(styles.sectionLayoutTitle, titleClassName)}>{title}</div>
        {actionBtn && (
          <div>
            <Button
              label={actionBtn.label}
              onClick={actionBtn.onClick}
              variant={actionBtn.variant || 'contained'}
              disabled={disabled}
            />
          </div>
        )}

        {onEdit && (
          <div className={styles.sectionLayoutButton}>
            <Tooltip title={disabled && disabledTooltip ? disabledTooltip : ''} show={disabled && !!disabledTooltip}>
              <Button
                label={strings.EDIT}
                onClick={onEdit}
                variant={actionBtn?.variant || 'outlined'}
                disabled={disabled}
                id={btnEditId}
              />
            </Tooltip>
          </div>
        )}
      </div>
      <div
        className={clsx(styles.sectionLayoutContent, contentClassName)}
        style={{ paddingRight: pr ? pr : '', paddingLeft: pl ? pl : '' }}
      >
        {children}
      </div>
    </Card>
  )
}

export default ScrollSpySection
